import * as React from 'preact/compat'
import cn from 'classnames'
import Api from '../../api'
import Loading from '../Loading'
import { captureException, loadStylesheet } from '../../common/helpers'
import styles from '../../../css/2fa.pcss.json'
import formCss from '../../../css/form.pcss.json'
import buttonsCss from '../../../css/buttons.pcss.json'
import { showToast } from '../toast'

interface PropTypes {
  close: () => void
}

interface StateTypes {
  loading: boolean,
  sending: boolean,
  error: boolean,
  qr?: string,
  url?: string,
  lemon: boolean
}

export default class TwoFAEnableForm extends React.Component<PropTypes, StateTypes> {
  state: StateTypes = {
    loading: true,
    sending: false,
    error: false,
    lemon: false
  }

  componentWillMount() {
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('2fa')
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('form')
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('buttons')
  }

  componentDidMount() {
    Api.get<{
      qr: string,
      url: string
    }>({ url: 'user/2fa-enable-info' })
      .then((response) => {
        this.setState({
          loading: false,
          qr: response.qr,
          url: response.url
        })
      })
      .catch(e => {
        captureException('TwoFA Enable Form', e)
        showToast({
          type: 'error',
          text: 'При загрузке формы произошла ошибка'
        })
        this.props.close()
      })
  }

  onSubmit = (event: React.TargetedEvent<HTMLFormElement>) => {
    event.preventDefault()
    const formData = new FormData(event.currentTarget)
    this.setState({
      sending: true
    })
    Api.post({ url: 'user/2fa-enable', body: formData })
      .then(response => {
        if (response.success) {
          showToast({
            type: 'success',
            text: 'Аутентификатор успешно привязан'
          })
          this.props.close()
          const buttons = document.querySelectorAll('[data-manage-2fa]')
          buttons.forEach(button => {
            button.innerHTML = 'Удалить аутентификатор'
            button.setAttribute('data-manage-2fa', 'disable')
          })
          return
        }
        this.setState({
          error: true,
          sending: false
        })
      })
      .catch(e => {
        captureException('TwoFA Enable Form', e)
        showToast({
          type: 'error',
          text: 'При подключении аутентификатора произошла ошибка'
        })
        this.setState({
          sending: false
        })
      })
  }

  onInput = (event: React.TargetedEvent<HTMLInputElement>) => {
    const { error } = this.state
    if (error) {
      this.setState({
        error: false
      })
    }
    if (event.currentTarget.value.toLowerCase() === 'lemon') {
      this.setState({
        lemon: true
      })
      setTimeout(() => {
        this.setState({
          lemon: false
        })
      }, 5500)
    }
  }

  render() {
    const { loading, qr, url, sending, error, lemon } = this.state

    if (loading) {
      return <Loading/>
    }
    // @ts-ignore
    return <form onSubmit={this.onSubmit} className={styles['form']}>
      <h2>Отсканируй QR-код</h2>
      <span>или нажми на него</span>
      <p className={styles['hint']}>Работает с приложениями<br/>Google Authentificator и Authy</p>
      <div className={styles['qr-container']}>
        <a href={url} className={cn({
          [styles['qr']]: true,
          [styles['qr--lemon']]: lemon
        })} dangerouslySetInnerHTML={{ __html: qr }}/>
        {lemon && <>
          <img alt="" className={styles['lemon']} src="/img/lemon.png"/>
          <img alt="" className={styles['tongue']} src="/img/tongue.png"/>
        </>}
      </div>
      <input
        type="text"
        name="otp"
        onInput={this.onInput}
        pattern='\d{6}'
        required
        className={cn(formCss['input'], styles['input'], {
          [formCss['input--error']]: error
        })}
        placeholder='Код из приложения'
        title='Шесть цифр без пробелов'
      />
      {error && <span class={styles['error']}>Неверный код</span>}
      <button
        type='submit'
        className={cn(buttonsCss['primary'], styles['button'])}
        disabled={sending}
        style={{ marginTop: '16px' }}
      >
        Привязать аутентификатор
      </button>
    </form>
  }
}
